export function initAccordion() {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion) => {
    const rows = accordion.querySelectorAll(".accordion__row");

    accordion.addEventListener("click", function (event) {
      // Use closest to find the element with the class accordion__heading-click
      const target = event.target.closest(".accordion__heading-click");

      if (target) {
        const row = target.closest(".accordion__row");

        // Toggle the 'active' class for the row
        if (row.classList.contains("active")) {
          row.classList.remove("active");
        } else {
          // Remove 'active' class from all rows within this accordion
          rows.forEach((r) => r.classList.remove("active"));
          row.classList.add("active");

          // Scroll to the top of the opened accordion row
          row.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  });
}
